import { createSelector } from '@reduxjs/toolkit';
import { message } from 'antd';
import _ from 'lodash';
import { all, put, select, takeLatest } from 'redux-saga/effects';
import { logger } from 'services';
import { deleteTaskInProjectTemplate, updateAutomationByIdAction } from '../../actions';
import { selectTemplateTask } from '../../selectors';
import { deleteProjectTemplateSubTask, deleteProjectTemplateTask, setProjectTemplateActiveRecord } from '../../slices';
const selectActiveRecord = createSelector((state)=>state.templates.project.activeRecord, (activeRecord)=>activeRecord);
const selectAutomationsInActiveTemplate = (state)=>{
    var _ref;
    var _state_templates_project_data_activeId_template, _state_templates_project_data_activeId;
    const { activeId } = state.templates.project;
    return (_ref = (_state_templates_project_data_activeId = state.templates.project.data[activeId]) === null || _state_templates_project_data_activeId === void 0 ? void 0 : (_state_templates_project_data_activeId_template = _state_templates_project_data_activeId.template) === null || _state_templates_project_data_activeId_template === void 0 ? void 0 : _state_templates_project_data_activeId_template.automations) !== null && _ref !== void 0 ? _ref : [];
};
function* getAutomationsForTask(taskId) {
    const automations = yield select(selectAutomationsInActiveTemplate);
    return automations.filter((e)=>{
        var _e_tags;
        return ((_e_tags = e.tags) === null || _e_tags === void 0 ? void 0 : _e_tags.taskTemplateInstanceReferenceId) === taskId && !e.deleted;
    });
}
function* markAutomationsAsDeletedForTask(taskId) {
    const automationsForTask = yield getAutomationsForTask(taskId);
    yield all(automationsForTask.map((automation)=>put(updateAutomationByIdAction({
            automation: _.cloneDeep({
                ...automation,
                deleted: true
            }),
            automationId: automation.automationId
        }))));
}
export function* isSameTaskOrChildTask(task, activeTaskId) {
    if (task.taskId === activeTaskId) {
        return true;
    }
    const { subTasks } = task;
    if (subTasks) {
        for(let i = 0; i < subTasks.length; i += 1){
            if (activeTaskId === subTasks[i]) {
                return true;
            }
            const subTask = yield select(selectTemplateTask(subTasks[i]));
            if (yield isSameTaskOrChildTask(subTask, activeTaskId)) {
                return true;
            }
        }
    }
    return false;
}
function* deleteTaskInTemplateSaga(action) {
    try {
        const { payload: { taskId } } = action;
        const task = yield select(selectTemplateTask(taskId));
        const activeRecord = yield select(selectActiveRecord);
        const shouldChangeActiveRecord = activeRecord && activeRecord.type === 'TASK' ? yield isSameTaskOrChildTask(task, activeRecord.id) : false;
        // Mark any automations associated with this task as deleted
        // This prevents save failures when the task is removed but automations still reference it
        yield markAutomationsAsDeletedForTask(taskId);
        if (task.projectPhase) {
            yield put(deleteProjectTemplateTask({
                taskId
            }));
            if (shouldChangeActiveRecord) {
                yield put(setProjectTemplateActiveRecord({
                    id: task.projectPhase.projectPhaseId,
                    type: 'PROJECT_PHASE'
                }));
            }
        } else {
            yield put(deleteProjectTemplateSubTask({
                taskId
            }));
            if (shouldChangeActiveRecord) {
                yield put(setProjectTemplateActiveRecord({
                    id: task.parentTask.taskId,
                    type: 'TASK'
                }));
            }
        }
    } catch (error) {
        logger.error('deleteTaskInTemplateSaga failed ', {
            error
        });
        message.error('There was an error deleting the task');
    }
}
export function* watchDeleteTaskInProjectTemplateSaga() {
    yield takeLatest(deleteTaskInProjectTemplate.type, deleteTaskInTemplateSaga);
}
